var React = require('react');

function PrepMaterial (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.36963 19.3913V13.5652C1.36963 8.0727 1.36963 5.32569 3.07667 3.62011C4.78372 1.91452 7.52926 1.91306 13.0218 1.91306H15.9349C21.4274 1.91306 24.1744 1.91306 25.88 3.62011C26.8326 4.57122 27.2535 5.84567 27.4385 7.73915M27.587 13.5652V19.3913C27.587 24.8839 27.587 27.6309 25.88 29.3365C24.1729 31.042 21.4274 31.0435 15.9349 31.0435H13.0218C7.52926 31.0435 4.78226 31.0435 3.07667 29.3365C2.12411 28.3854 1.70317 27.1109 1.51819 25.2174M8.65224 19.3913H15.9349M8.65224 13.5652H10.1088M20.3044 13.5652H14.4783","stroke":"#02BF91","strokeWidth":"2.18478","strokeLinecap":"round"}));
}

PrepMaterial.defaultProps = {"width":"29","height":"33","viewBox":"0 0 29 33","fill":"none"};

module.exports = PrepMaterial;

PrepMaterial.default = PrepMaterial;
